
<template>
<Loader v-if="loader" />
    <div class="table-container">
        <div class="card">
            <DataTable :value="items" :paginator="true" :rows="10" :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
                currentPageReportTemplate="{first} a {last} di {totalRecords}">
                <template #header>
                        <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                            </span>
                        </div>
                    </template>
                <template #empty>
                    <div class="text-center">Nessun dato trovato.</div>
                </template>
                <Column field="pod" header="Pod" :sortable="true"></Column>
                <Column field="cf" header="Cod. Fiscale" :sortable="true"></Column>
                <Column field="regime_compensazione" header="Regime compensazione" :sortable="true"></Column>
                <Column field="tipo_comunicazione" header="Tipo comunicazione" :sortable="true"></Column>
                <Column field="type" header="Tipo" :sortable="true"></Column>
                <Column field="anno_validita" header="Anno validità" :sortable="true"></Column>
                <Column field="data_inizio" header="Data inizio" :sortable="true" style="min-width: 100px">
                    <template #body="slotProps">
                    {{formatDate(slotProps.data.data_inizio)}}
                    </template>
                </Column>
                <Column field="data_fine" header="Data fine" :sortable="true" style="min-width: 100px">
                    <template #body="slotProps">
                    {{formatDate(slotProps.data.data_fine)}}
                    </template>
                </Column>
                <Column field="data_cessazione" header="Data cessazione" :sortable="true" style="min-width: 100px">
                    <template #body="slotProps">
                    {{formatDate(slotProps.data.data_cessazione)}}
                    </template>
                </Column>
                <Column field="esito" header="Esito" :sortable="true">
                    <template #body="slotProps">
                    <i v-if="slotProps.data.esito" class="pi pi-check text-primary"></i>
                    <i v-else class="pi pi-times text-orange-200"></i>
                    </template>
                </Column>
                <Column field="cod_causale" header="Cod. causale" :sortable="true"></Column>
                <Column field="motivazione" header="Motivazione" :sortable="true"></Column>
            </DataTable>
        </div>                        
    </div>
</template>

<script>

import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
     setup() {
                
        const loader = ref(false);
        const items = ref([]);
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const formatDate = self.appContext.config.globalProperties.$formatDate
        const service = new Service(self.$http, self.$eventBus)

        onMounted(() => {       
            getData();      
        })
        const getData = () => {
            loader.value = true;
            service.getBonusSociale().then((res) => {
              items.value = res.items

            }).finally(() => {
                loader.value = false;
            })
        }

        
        return { 
          items,
          loader,
          formatDate, 
          filters,
         }
    }
}
</script>
